import React, { ComponentProps, ElementType } from 'react';
import { OrderPageTypography } from '../../orderPage/themedComponents/OrderPageTypography';
import { rescheduleTheme } from '../rescheduleTheme';

export const rescheduleTypographyDefaults = {
  fontFamily: rescheduleTheme.font,
  lineHeight: 'inherit',
  letterSpacing: 'inherit',
  color: 'inherit',
} as const;

type RescheduleTypographyProps = ComponentProps<typeof OrderPageTypography> & {
  component?: ElementType;
  dir?: 'ltr' | 'rtl';
  role?: string;
};

export const RescheduleTypography = ({ style, ...typographyProps }: RescheduleTypographyProps) => (
  <OrderPageTypography {...typographyProps} style={{ ...rescheduleTypographyDefaults, ...style }} />
);
